<template>
  <div>
    <slot/>
  </div>
</template>

<script setup>
import { onMounted } from "vue"

onMounted(() => {
  if ($(".l-table tr.cred").length < 1) {
    $(".credToggle").hide()
  }
})
</script>
